// A Live production card's pipeline: the status steps, the moves each status allows, the one step back, and the two
// date helpers the Production page and the Longform series panel share. HD-8: moved here from components/VideoCard.jsx
// (the retired video-card module) unchanged.


export const LIVE_TRANSITIONS = {
  Scripted:   ['Filming', 'Incomplete', 'Archived'],
  Filming:    ['Filmed',  'Scripted',  'Incomplete', 'Archived'],
  Filmed:     ['Editing', 'Filming',   'Incomplete', 'Archived'],
  Editing:    ['Qual',    'Filmed',    'Incomplete', 'Archived'],
  Qual:       ['Approved','Editing'],
  Approved:   ['Posted',  'Qual'],
  Posted:     ['Approved'],
  Incomplete: ['Filming', 'Archived'],
  // Archived = set aside for now, may shoot later (nothing is wrong: that is Incomplete). Restorable to the start of
  // the pipeline or straight to set.
  Archived:   ['Filming', 'Scripted'],
};

export const BACK_STEP = {
  Filming:  'Scripted',
  Filmed:   'Filming',
  Editing:  'Filmed',
  Qual:     'Editing',
  Approved: 'Qual',
  Posted:   'Approved',
  Archived: 'Scripted',
};

export function formatDate(str) {
  if (!str) return '—';
  const [y, m, d] = str.slice(0, 10).split('-').map(Number);
  return new Date(y, m - 1, d).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}

export function toInputDate(str) {
  if (!str) return '';
  return typeof str === 'string' ? str.slice(0, 10) : new Date(str).toISOString().slice(0, 10);
}
